
import jquery from "jquery";
window.$ = window.jQuery = jquery;


const selectors = {
  nav: '.cart-sticky__header',
  cartTable: '.cart-header__wrapper'
}

const classes = {
  sticky: 'is-sticky'
}

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function handleScroll(navElement){
  const cartTableHeight = $(selectors.cartTable).height();
  if( $(window).scrollTop() > cartTableHeight && !(navElement.hasClass(classes.sticky))){
    navElement.addClass(classes.sticky);
  } else if ($(window).scrollTop() <= cartTableHeight){
    navElement.removeClass(classes.sticky);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const $stickyNav = $(selectors.nav);
  if (!!$stickyNav.length) {
    
    $(window).on('scroll', function () {
      debounce(handleScroll($stickyNav), 100, true)
    });
  }
});


